import { useState } from 'react';
import { ImageIcon } from 'lucide-react';
import type { PendingBoatImage } from '@/modules/inventory/services/boatMediaApi';

/**
 * #1219 (F5) — the held image's auth-gated preview stream can fail (404, 401,
 * a storage hiccup). Without an onError fallback the <img> shows the browser's
 * broken-image icon; this swaps to the same ImageIcon fallback DocumentIcon
 * renders for a non-PDF document, keeping an accessible name (the file name)
 * via role="img" + aria-label on the fallback wrapper.
 */
export function PendingImageThumbnail({ item }: { item: PendingBoatImage }) {
  const [failed, setFailed] = useState(false);

  if (failed) {
    return (
      <div
        role="img"
        aria-label={item.file_name}
        className="flex h-full w-full items-center justify-center"
      >
        <ImageIcon className="size-8 text-muted-foreground" aria-hidden="true" />
      </div>
    );
  }

  return (
    <img
      src={item.preview_url}
      alt={item.file_name}
      className="h-full w-full object-cover"
      loading="lazy"
      onError={() => setFailed(true)}
    />
  );
}
